import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, IconButton } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import ReactPlayer from 'react-player';
import { getOptimXBackgroundStyle } from '../../../../catalog/Website';
import { context } from '../../../../globalState/GlobalState';
import './css/SocialsVideoPopup.css';
import { isValidObject, isValidString } from '../../../../catalog/Validity';

const SocialsVideoPopup = (props) => {
    const { open, title, url, onCancel } = props;
    const { globalState } = useContext(context);

    return (
        <div>
            <Dialog className="pop-up" onClose={onCancel} open={open} fullWidth maxWidth="lg">
                <div className="pop-up-title pop-up-title-socials-video p-l-20px p-r-20px font-size-2xl text-white" style={getOptimXBackgroundStyle(globalState)}>
                    <div className="pop-up-title-title pop-up-title-title-socials-video">
                        {isValidObject(globalState.silhouetteLogo) && isValidString(globalState.silhouetteLogo.logo4) ? (<img className="" src={globalState.silhouetteLogo.logo4} alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />) : null}
                        <p>{title}</p>
                    </div>
                    <IconButton onClick={onCancel}>
                        <CloseRounded className="pop-up-title-close" />
                    </IconButton>
                </div>
                <DialogContent className="pop-up-content pop-up-content-socials-video">
                    <ReactPlayer
                        className=""
                        url={url}
                        controls
                        playing
                        width="100%"
                        height="100%"
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

SocialsVideoPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default SocialsVideoPopup;
